<template>
  <section class="search-cities-wrapper">
    <el-card v-if="!!items.length" shadow="never">
      <div slot="header" class="clearfix">
        <h2>{{ $t(`${base}.cities.title`, { name: locationName }) }}</h2>
      </div>

      <div class="content-link" :class="{ 'is-closed': !openItems }">
        <div v-for="item in items" :key="item.code">
          <nuxt-link
            slot="label"
            :to="{
              name: 'search-type',
              params: {
                type: $t('router.search_type.type.city'),
                value: item.slug,
                tab: $t('router.search_type.tab.tours'),
              },
            }"
            @click.native="handleLoading"
          >
            {{ $t(`${base}.cities.tours_in`, { name: item.name }) }}
          </nuxt-link>
        </div>
      </div>

      <div v-if="items.length > limitMin">
        <el-button
          type="text"
          class="el-button el-button--text el-button--medium"
          @click="handleChange('items')"
          >{{ $t(`${base}.${itemsText}`) }}</el-button
        >
      </div>
    </el-card>

    <el-card v-if="!!durations.length" shadow="never">
      <div slot="header" class="clearfix">
        <h2>{{ $t(`${base}.duration.title`, { name: locationName }) }}</h2>
      </div>

      <div class="content-link" :class="{ 'is-closed': !openDurations }">
        <div v-for="duration in durations" :key="duration">
          <nuxt-link
            slot="label"
            :to="{
              name: type === 'country' ? 'search' : 'search-type',
              query:
                type === 'country'
                  ? {
                      type,
                      value: $route.params.value,
                      duration: [duration, duration],
                    }
                  : {},
              params:
                type === 'country'
                  ? {}
                  : {
                      type: $t(`router.search_type.type.${type}`),
                      value: $route.params.value,
                      tab: $t('router.search_type.tab.tours'),
                      days: $t(`${base}.duration.link`, { days: duration }),
                    },
            }"
            @click.native="handleLoading"
          >
            {{ $t(`${base}.duration.tours_for`, { days: duration }) }}
          </nuxt-link>
        </div>
      </div>

      <div v-if="durations.length > limitMin">
        <el-button
          type="text"
          class="el-button el-button--text el-button--medium"
          @click="handleChange('durations')"
          >{{ $t(`${base}.${durationText}`) }}</el-button
        >
      </div>
    </el-card>
  </section>
</template>

<script>
export default {
  name: 'LadSearchFastLinks',
  props: {
    locationName: { type: String, required: true },
    items: { type: Array, required: true },
    type: { type: String, required: true, default: 'country' },
    durations: { type: Array, default: () => [], required: false },
  },
  data() {
    return {
      base: 'search.country.fast_links',
      limitMin: 6,
      openItems: false,
      openDurations: false,
    }
  },
  computed: {
    itemsText() {
      return this.openItems ? 'show_less' : 'show_more'
    },
    durationText() {
      return this.openDurations ? 'show_less' : 'show_more'
    },
  },
  methods: {
    handleLoading() {
      this.$nuxt.$emit('custom-loading', { enabled: true, source: 'search' })
    },
    handleChange(type) {
      switch (type) {
        case 'durations':
          this.openDurations = !this.openDurations
          break
        case 'items':
          this.openItems = !this.openItems
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search-cities-wrapper {
  background-color: transparent;
  margin-top: 20px;
  padding: 0;

  .content-link {
    &.is-closed > div:nth-child(n + 6) {
      display: none;
    }
  }
}
</style>
